/** CoStar.Api.Analytics.ViewModels.Charting.LegendSymbolStyle */
export var LegendSymbolStyle;
(function (LegendSymbolStyle) {
    LegendSymbolStyle[LegendSymbolStyle["Line"] = 0] = "Line";
    LegendSymbolStyle[LegendSymbolStyle["DashedLine"] = 1] = "DashedLine";
    LegendSymbolStyle[LegendSymbolStyle["Rectangle"] = 2] = "Rectangle";
    LegendSymbolStyle[LegendSymbolStyle["Square"] = 3] = "Square";
    LegendSymbolStyle[LegendSymbolStyle["Circle"] = 4] = "Circle";
    LegendSymbolStyle[LegendSymbolStyle["Star"] = 5] = "Star";
    LegendSymbolStyle[LegendSymbolStyle["Point"] = 6] = "Point";
    LegendSymbolStyle[LegendSymbolStyle["Image"] = 7] = "Image";
})(LegendSymbolStyle || (LegendSymbolStyle = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.ChartingSkins */
export var ChartingSkins;
(function (ChartingSkins) {
    ChartingSkins[ChartingSkins["CoStarSuiteSkin"] = 0] = "CoStarSuiteSkin";
    ChartingSkins[ChartingSkins["CoStarGoSkin"] = 1] = "CoStarGoSkin";
    ChartingSkins[ChartingSkins["ProductSuiteSkin"] = 2] = "ProductSuiteSkin";
    ChartingSkins[ChartingSkins["CoStarReportSkin"] = 3] = "CoStarReportSkin";
    ChartingSkins[ChartingSkins["CoStarReport2Skin"] = 4] = "CoStarReport2Skin";
    ChartingSkins[ChartingSkins["CoStarSuite2Skin"] = 5] = "CoStarSuite2Skin";
    ChartingSkins[ChartingSkins["CoStarApartmentSkin"] = 6] = "CoStarApartmentSkin";
})(ChartingSkins || (ChartingSkins = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.FontSize */
export var FontSize;
(function (FontSize) {
    FontSize[FontSize["Medium"] = 0] = "Medium";
    FontSize[FontSize["Small"] = 1] = "Small";
    FontSize[FontSize["Large"] = 2] = "Large";
})(FontSize || (FontSize = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.GraphicFormat */
export var GraphicFormat;
(function (GraphicFormat) {
    GraphicFormat[GraphicFormat["Jpeg"] = 0] = "Jpeg";
    GraphicFormat[GraphicFormat["Png"] = 1] = "Png";
    GraphicFormat[GraphicFormat["Bmp"] = 2] = "Bmp";
    GraphicFormat[GraphicFormat["Emf"] = 3] = "Emf";
})(GraphicFormat || (GraphicFormat = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.SmoothingOptions */
export var SmoothingOptions;
(function (SmoothingOptions) {
    SmoothingOptions[SmoothingOptions["Standard"] = 0] = "Standard";
    SmoothingOptions[SmoothingOptions["ThreePeriodTrailingAverage"] = 1] = "ThreePeriodTrailingAverage";
    SmoothingOptions[SmoothingOptions["StraightLineTrend"] = 2] = "StraightLineTrend";
    SmoothingOptions[SmoothingOptions["Smoothed"] = 3] = "Smoothed";
})(SmoothingOptions || (SmoothingOptions = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.TimeIntervalLabeling */
export var TimeIntervalLabeling;
(function (TimeIntervalLabeling) {
    TimeIntervalLabeling[TimeIntervalLabeling["Default"] = 0] = "Default";
    TimeIntervalLabeling[TimeIntervalLabeling["YearOnly"] = 1] = "YearOnly";
    TimeIntervalLabeling[TimeIntervalLabeling["YearAndInterval"] = 2] = "YearAndInterval";
    TimeIntervalLabeling[TimeIntervalLabeling["TwoYearsLabelFormat"] = 3] = "TwoYearsLabelFormat";
})(TimeIntervalLabeling || (TimeIntervalLabeling = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.TimeIntervalType */
export var TimeIntervalType;
(function (TimeIntervalType) {
    TimeIntervalType[TimeIntervalType["None"] = 0] = "None";
    TimeIntervalType[TimeIntervalType["Annual"] = 1] = "Annual";
    TimeIntervalType[TimeIntervalType["Semiannual"] = 2] = "Semiannual";
    TimeIntervalType[TimeIntervalType["Quarterly"] = 4] = "Quarterly";
    TimeIntervalType[TimeIntervalType["Monthly"] = 12] = "Monthly";
    TimeIntervalType[TimeIntervalType["Daily"] = 365] = "Daily";
})(TimeIntervalType || (TimeIntervalType = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.CannedTimeframe */
export var CannedTimeframe;
(function (CannedTimeframe) {
    CannedTimeframe[CannedTimeframe["Last7Days"] = 0] = "Last7Days";
    CannedTimeframe[CannedTimeframe["Last30Days"] = 1] = "Last30Days";
    CannedTimeframe[CannedTimeframe["Last90Days"] = 2] = "Last90Days";
    CannedTimeframe[CannedTimeframe["MonthToDate"] = 3] = "MonthToDate";
    CannedTimeframe[CannedTimeframe["PreviousMonth"] = 4] = "PreviousMonth";
    CannedTimeframe[CannedTimeframe["QuarterToDate"] = 5] = "QuarterToDate";
    CannedTimeframe[CannedTimeframe["PreviousQuarter"] = 6] = "PreviousQuarter";
    CannedTimeframe[CannedTimeframe["Last6Months"] = 7] = "Last6Months";
    CannedTimeframe[CannedTimeframe["SinceLastChecked"] = 8] = "SinceLastChecked";
    CannedTimeframe[CannedTimeframe["SinceYesterday"] = 9] = "SinceYesterday";
    CannedTimeframe[CannedTimeframe["PreviousYear"] = 10] = "PreviousYear";
    CannedTimeframe[CannedTimeframe["AllTime"] = 11] = "AllTime";
    CannedTimeframe[CannedTimeframe["YearToDate"] = 12] = "YearToDate";
    CannedTimeframe[CannedTimeframe["Last3Days"] = 13] = "Last3Days";
    CannedTimeframe[CannedTimeframe["Last14Days"] = 14] = "Last14Days";
    CannedTimeframe[CannedTimeframe["Last60Days"] = 15] = "Last60Days";
    CannedTimeframe[CannedTimeframe["Last365Days"] = 16] = "Last365Days";
    CannedTimeframe[CannedTimeframe["Last180Days"] = 17] = "Last180Days";
    CannedTimeframe[CannedTimeframe["Previous2Years"] = 18] = "Previous2Years";
    CannedTimeframe[CannedTimeframe["CalendarYear2YearsAgo"] = 19] = "CalendarYear2YearsAgo";
    CannedTimeframe[CannedTimeframe["CalendarYear3YearsAgo"] = 20] = "CalendarYear3YearsAgo";
    CannedTimeframe[CannedTimeframe["Last1Year"] = 101] = "Last1Year";
    CannedTimeframe[CannedTimeframe["Last2Years"] = 102] = "Last2Years";
    CannedTimeframe[CannedTimeframe["Last3Years"] = 103] = "Last3Years";
    CannedTimeframe[CannedTimeframe["Last4Years"] = 104] = "Last4Years";
    CannedTimeframe[CannedTimeframe["Last5Years"] = 105] = "Last5Years";
    CannedTimeframe[CannedTimeframe["Last6Years"] = 106] = "Last6Years";
    CannedTimeframe[CannedTimeframe["Last7Years"] = 107] = "Last7Years";
    CannedTimeframe[CannedTimeframe["Last8Years"] = 108] = "Last8Years";
    CannedTimeframe[CannedTimeframe["Last9Years"] = 109] = "Last9Years";
    CannedTimeframe[CannedTimeframe["Last10Years"] = 110] = "Last10Years";
    CannedTimeframe[CannedTimeframe["Last11Years"] = 111] = "Last11Years";
    CannedTimeframe[CannedTimeframe["Last12Years"] = 112] = "Last12Years";
    CannedTimeframe[CannedTimeframe["Last13Years"] = 113] = "Last13Years";
    CannedTimeframe[CannedTimeframe["Last14Years"] = 114] = "Last14Years";
    CannedTimeframe[CannedTimeframe["Last15Years"] = 115] = "Last15Years";
    CannedTimeframe[CannedTimeframe["Last16Years"] = 116] = "Last16Years";
    CannedTimeframe[CannedTimeframe["Last17Years"] = 117] = "Last17Years";
    CannedTimeframe[CannedTimeframe["Last18Years"] = 118] = "Last18Years";
    CannedTimeframe[CannedTimeframe["Last19Years"] = 119] = "Last19Years";
    CannedTimeframe[CannedTimeframe["Last20Years"] = 120] = "Last20Years";
})(CannedTimeframe || (CannedTimeframe = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.BaseDivisor */
export var BaseDivisor;
(function (BaseDivisor) {
    BaseDivisor[BaseDivisor["Ones"] = 1] = "Ones";
    BaseDivisor[BaseDivisor["Tens"] = 10] = "Tens";
    BaseDivisor[BaseDivisor["Hundreds"] = 100] = "Hundreds";
    BaseDivisor[BaseDivisor["Thousands"] = 1000] = "Thousands";
    BaseDivisor[BaseDivisor["Millions"] = 1000000] = "Millions";
    BaseDivisor[BaseDivisor["Billions"] = 1000000000] = "Billions";
})(BaseDivisor || (BaseDivisor = {}));
/** CoStar.Api.Analytics.ViewModels.Charting.WhichAxis */
export var WhichAxis;
(function (WhichAxis) {
    WhichAxis[WhichAxis["XPrimary"] = 0] = "XPrimary";
    WhichAxis[WhichAxis["XSecondary"] = 1] = "XSecondary";
    WhichAxis[WhichAxis["YPrimary"] = 2] = "YPrimary";
    WhichAxis[WhichAxis["YSecondary"] = 3] = "YSecondary";
})(WhichAxis || (WhichAxis = {}));
